export default "__VITE_ASSET__BU7okgHQ__"